import script from "./ship_receive.vue?vue&type=script&setup=true&lang=js"
export * from "./ship_receive.vue?vue&type=script&setup=true&lang=js"

import "./ship_receive.vue?vue&type=style&index=0&id=88bd6148&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88bd6148"]])

export default __exports__